<div style="" class="mat-card-selected-summary" sm-restrict-width>
  <div sm-center>
    <mat-card-title>{{ title }}</mat-card-title>
    <h3 *ngIf="subTitle">{{ subTitle }}</h3>
  </div>
  <mat-list class="smc-booking-selected-summary-list">
    <mat-list-item
      class="smc-booking-selected-summary-list-item"
      *ngFor="let service of booking.getServices()"
    >
      <img
        mat-list-avatar
        *ngIf="
          service.getStylist()?.getPhotoUrl() != undefined &&
          service.getStylist()?.getPhotoUrl() != ''
        "
        [alt]="
          service.getStylist()?.getFirstName() +
          ' ' +
          service.getStylist()?.getLastName()
        "
        src="https://salonmonster.com/userfiles/profile_pics/{{
          service.getStylist()?.getPhotoUrl()
        }}"
      />
      <h3 mat-line>
        {{ service.getName() }} with
        <span *ngIf="service.getStylist()">
          {{ service.getStylist().getFirstName() }}
          {{ service.getStylist().getLastName() }}</span
        >
      </h3>
      <p mat-line>
        {{
          service.getServiceDefinition().getStartingAt() == 1 &&
          service.getStylist().getHidePrices() !== 1
            ? ('BOOKINGS.STARTING_AT' | translate)
            : ''
        }}
        <span *ngIf="service.getStylist().getHidePrices() !== 1">{{
          service.getServiceDefinition().getPrice() | salonMonsterCurrency
        }}</span>
        <span *ngIf="service.getStylist().getHideDurations() !== 1">
          {{
            ('BOOKINGS.ABOUT' | translate) + ' ' +
              (service.getDurations().startDuration +
                service.getDurations().processDuration +
                service.getDurations().finishDuration
                | SalonMonsterFormatDurationPipe)
          }}
        </span>
      </p>
    </mat-list-item>
  </mat-list>
</div>
